/* eslint-disable */
import type { MenuProps } from 'antd';
import UnMuteIcon from './images/unMute.svg?react';
import VideoIcon from './images/video.svg?react';
import HostIcon from './images/host.svg?react';
import CoHostIcon from './images/coHost.svg?react';
import PinIcon from './images/pin.svg?react';
import ZoomInIcon from './images/zoomIn.svg?react';
import EditIcon from './images/edit.svg?react';
import styles from './index.module.scss';
import type { CardMoreOperateProps } from './type';
import { CardMoreOperateKey } from './type';

const CardMoreOperate = ({ children, className, onClick }: CardMoreOperateProps) => {
  const items: MenuProps['items'] = useMemo(
    () => [
      // {
      //   key: CardMoreOperateKey.MUTE,
      //   label: (
      //     <div className={styles.menuLabel}>
      //       Ask to unmute <UnMuteIcon />
      //     </div>
      //   ),
      // },
      // {
      //   key: CardMoreOperateKey.WATCH,
      //   label: (
      //     <div className={styles.menuLabel}>
      //       Ask to start video <VideoIcon />
      //     </div>
      //   ),
      // },
      // {
      //   type: 'divider',
      // },
      // {
      //   key: CardMoreOperateKey.HOST,
      //   label: (
      //     <div className={styles.menuLabel}>
      //       Make host <HostIcon />
      //     </div>
      //   ),
      // },
      // {
      //   key: CardMoreOperateKey.CO_HOST,
      //   label: (
      //     <div className={styles.menuLabel}>
      //       Make co-host <CoHostIcon />
      //     </div>
      //   ),
      // },
      // {
      //   type: 'divider',
      // },
      {
        key: CardMoreOperateKey.PIN,
        label: (
          <div className={styles.menuLabel}>
            Pin <PinIcon />
          </div>
        ),
      },
      {
        key: CardMoreOperateKey.FULL_SCREEN,
        label: (
          <div className={styles.menuLabel}>
            Full screen <ZoomInIcon />
          </div>
        ),
      },
      // {
      //   type: 'divider',
      // },
      // {
      //   key: CardMoreOperateKey.EDIT,
      //   label: (
      //     <div className={styles.menuLabel}>
      //       Change name <EditIcon />
      //     </div>
      //   ),
      // },
    ],
    []
  );

  return (
    <Dropdown
      className={cls(className)}
      overlayClassName={styles.dropdownwrapper}
      menu={{
        items,
        onClick,
      }}
      placement="topRight"
    >
      <div>{children}</div>
    </Dropdown>
  );
};

export default CardMoreOperate;
